/**
 * Class to assist in building "filter" objects for
 * API query parameters.
 */
export class FilterBuilder {
  #filter = {};

  addFilter(key, value) {
    this.#filter[key] = value;
    return this;
  }

  removeFilter(key) {
    delete this.#filter[key];
    return this;
  }

  /**
   * Exactly the same as {@link this.addFilter()} but having
   * this separate method gives semantic accuracy.
   */
  updateFilter(key, value) {
    this.#filter[key] = value;
    return this;
  }

  reset() {
    this.#filter = {};
  }

  get() {
    return this.#filter;
  }
}
